import React from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import FilterGroup from '../FilterGroup';
import FormSlider from '../../../ui/form/form-slider';

import getBudgetValue from './utils/getBudgetValue';

const FILTER_NAME = 'budget';

const PriceSliderFilter = props => {
  const budget = props.budget || '';
  const splittedBudget = budget.split('-');
  const budgetMin = parseInt(splittedBudget[0], 10) || 0;
  const budgetMax = parseInt(splittedBudget[1], 10) || props.maxPriceInCity;

  const handleOnChange = ({ sliderFrom, sliderTo }) => {
    const { updateFiltersWith, maxPriceInCity } = props;

    const budgetValue = getBudgetValue({
      minBudget: sliderFrom,
      maxBudget: sliderTo,
      maxPrice: maxPriceInCity
    });

    updateFiltersWith({ [FILTER_NAME]: budgetValue });
  };

  return (
    <FilterGroup
      classModifier="price-range"
      label={trans('search.filter.price.range')}
    >
      {props.disablePrice && (
        <div className="filter-group--price-range-blocker" />
      )}
      <FormSlider
        histogramMaxHeight={30}
        onChange={handleOnChange}
        sliderFrom={budgetMin}
        sliderTo={budgetMax}
        currency={props.currency}
        unitPrices={props.unitPrices}
        maxPrice={props.maxPriceInCity}
        trackingPrefix="ga-search-form-price-slider"
      />
    </FilterGroup>
  );
};

PriceSliderFilter.propTypes = {
  budget: PropTypes.string,
  updateFiltersWith: PropTypes.func.isRequired,
  currency: PropTypes.object.isRequired,
  unitPrices: PropTypes.arrayOf(PropTypes.number),
  maxPriceInCity: PropTypes.number.isRequired,
  disablePrice: PropTypes.bool
};

PriceSliderFilter.defaultProps = {
  budget: '',
  unitPrices: [],
  disablePrice: false
};

export default PriceSliderFilter;
